import { useState } from 'react'
import styled from 'styled-components'

import ChevronDown from '~/shared/assets/icons/ChevronDown'
import ChevronUp from '~/shared/assets/icons/ChevronUp'
import theme from '~/shared/styles/theme'

interface Props {
  title: string
  contents: any
}

function Accordion({ title, contents }: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <Wrapper>
      <Title onClick={() => setIsOpen((prev: boolean) => !prev)}>
        {title}

        {isOpen ? <ChevronUp /> : <ChevronDown />}
      </Title>
      {isOpen && typeof contents === 'string' ? (
        <Contents
          dangerouslySetInnerHTML={{
            __html: contents || '',
          }}
        />
      ) : isOpen && typeof contents === 'object' ? (
        <Contents>{contents}</Contents>
      ) : null}
    </Wrapper>
  )
}

export default Accordion

const Wrapper = styled.li`
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 100%;
  height: auto;

  list-style: none;

  border: 1px solid #c1c3c2;
  border-radius: 12px;
`

const Title = styled.div`
  cursor: pointer;

  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;
  height: 85px;
  padding: 24px 36px;

  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 33px;

  .text {
    display: flex;
    align-items: center;

    font-size: 18px;
    font-weight: 500;
    font-style: normal;
    color: #111827;
  }

  .faq-icon {
    margin-right: 16px;
  }

  .chevron-icon {
    position: absolute;
    right: 0;
    color: #94a3b8;
  }

  @media ${theme.device.medium} {
    gap: 10px;
    padding: 24px 20px;
    font-size: 18px;
    line-height: 140%;
  }
`

const Contents = styled.p`
  position: sticky;
  top: 50px;

  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-start;
  align-self: stretch;

  box-sizing: border-box;
  width: 100%;
  margin-bottom: 20px;
  padding: 24px 36px;

  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  line-height: 28px;

  border-radius: 4px 24px 24px;

  @media ${theme.device.medium} {
    padding: 24px 20px;
  }
`
